import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import Modal from 'cccisd-modal';
import axios from 'cccisd-axios';
import Tooltip from 'cccisd-tooltip';
import notification from 'cccisd-notification';
import IconPencil from 'cccisd-icons/pencil';

import CareCoordinatorForm from 'js/components/CareCoordinatorForm';

const Boilerplate = window.cccisd && window.cccisd.boilerplate;
const Fortress = window.cccisd && window.cccisd.fortress;

const EditCareCoordinator = props => {
    const modal = useRef();
    const { row, loadData } = props;
    const currentRole = Fortress.user && Fortress.user.acting.role.handle;
    const isSupervisor = currentRole === 'supervisor';

    const onSubmit = async values => {
        const response = await axios.put(Boilerplate.route('api.nexus.pawn.update', { pawn: row['pawn.pawnId'] }), {
            pawnHash: row['pawn.pawnHash'],
            role: 'careCoordinator',
            firstName: values.firstName,
            first_name: values.firstName,
            lastName: values.lastName,
            last_name: values.lastName,
            email: values.email,
            username: values.email,
            adminId: values.adminId,
            phoneNumber: values.phoneNumber,
            phone: values.phoneNumber,
            enrolledInSmartwrap: values.enrolledInSmartwrap,
            administerPageAccess: values.administerPageAccess,
            dashboardPageAccess: values.dashboardPageAccess,
            managePageAccess: values.managePageAccess,
            receiveAlertsImmediately: values.receiveAlertsImmediately,
            receiveAlertsDigest: values.receiveAlertsDigest,
            receiveNotifications: values.receiveNotifications,
            supervisorReceiveAlertsImmediate: values.supervisorReceiveAlertsImmediate,
            supervisorReceiveAlertsDigest: values.supervisorReceiveAlertsDigest,
            supervisorReceiveNotifications: values.supervisorReceiveNotifications,
            exitDate: values.exitDate,
            exitReasonCareCoordinator: values.exitReasonCareCoordinator,
            group: values.site,
            ...(isSupervisor || values.enrolledInSmartwrap ? { parentPawns: values.supervisor } : {}),
        });

        if (response.data.errors) {
            let errorMessage = response.data.errors;
            if (typeof response.data.errors === 'object') {
                errorMessage = Object.values(response.data.errors).flat().join(' ');
            }
            notification({ type: 'danger', message: errorMessage });
            return Promise.reject(response.data.errors);
        }

        await loadData();
        notification({ type: 'success', message: 'Care Coordinator edited.' });
        await modal.current.close();
    };

    return (
        <Modal
            ref={modal}
            trigger={
                <Tooltip title="Edit">
                    <button type="button" className="btn btn-xs btn-success">
                        <IconPencil />
                    </button>
                </Tooltip>
            }
            title="Edit Care Coordinator"
        >
            <CareCoordinatorForm
                onSubmit={onSubmit}
                isEdit
                initialValues={{
                    firstName: row['fields.firstName'],
                    lastName: row['fields.lastName'],
                    email: row['fields.email'],
                    adminId: row['fields.adminId'],
                    phoneNumber: row['fields.phoneNumber'],
                    enrolledInSmartwrap: row['fields.enrolledInSmartwrap'] || false,
                    administerPageAccess: row['fields.administerPageAccess'] || false,
                    dashboardPageAccess: row['fields.dashboardPageAccess'] || false,
                    managePageAccess: row['fields.managePageAccess'] || false,
                    receiveAlertsImmediately: row['fields.receiveAlertsImmediately'] || false,
                    receiveAlertsDigest: row['fields.receiveAlertsDigest'] || false,
                    receiveNotifications: row['fields.receiveNotifications'] || false,
                    supervisorReceiveAlertsImmediate: row['fields.supervisorReceiveAlertsImmediate'] || false,
                    supervisorReceiveAlertsDigest: row['fields.supervisorReceiveAlertsDigest'] || false,
                    supervisorReceiveNotifications: row['fields.supervisorReceiveNotifications'] || false,
                    exitDate: row['fields.exitDate'],
                    exitReasonCareCoordinator: row['fields.exitReasonCareCoordinator'] || '',
                    site: [row['ancestorGroups.site.group.groupId']],
                    supervisor: row['parentRoles.supervisor.pawn.pawnId'] || '',
                }}
            />
        </Modal>
    );
};

EditCareCoordinator.propTypes = {
    loadData: PropTypes.func,
    row: PropTypes.object,
};

export default EditCareCoordinator;
